import styled from 'styled-components';
import RoomSizeSvg from '../../assets/mytrips/room-size.svg';

const RoomSizeIcon = styled(RoomSizeSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default RoomSizeIcon;
